import { useTheme } from '@mui/material/styles';
import React, { useCallback } from 'react';

import { useAuth } from '../../../hooks/auth/use-auth';
import { useFeatureToggle } from '../../../hooks/use-feature-toggle';
import { useTranslations } from '../../../hooks/use-translations';
import { LogoutIcon, QuestionIcon, SettingsIcon } from '../../icons';

import { MenuListItems } from './Sidebar';

export const useAuthMenu = (): MenuListItems => {
  const t = useTranslations('sidebar.authMenu');
  const theme = useTheme();
  const { featureToggle } = useFeatureToggle();
  const { logout } = useAuth();

  const color = theme.palette.mode === 'dark' ? theme.palette.common.white : theme.palette.grey[500];

  const result: MenuListItems = [];

  if (!featureToggle['page.help.hidden']) {
    result.push({
      title: t('Help'),
      target: '/help',
      icon: <QuestionIcon color={color} />,
      demo: true,
    });
  }

  if (!featureToggle['page.settings.hidden']) {
    result.push({
      title: t('Settings'),
      target: '/settings',
      icon: <SettingsIcon color={color} />,
      demo: false,
    });
  }

  result.push({
    title: t('LogOut'),
    icon: <LogoutIcon color={color} />,
    onClick: logout,
  });

  return result;
};
